import React from 'react';

import BEM from '../../Utilities/BEM/index.jsx';


class Badge extends React.Component {
  render() {
    return (
      <span className={BEM.classString('cs-badge', this.props.variant)}>
        {this.props.children}
      </span>
    );
  }
}


export default Badge;

